import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import * as _ from 'lodash';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {WindowActionsService} from '../../../services/common/window-actions/window-actions.service';
import {RoutingGroupApiService} from '../../../services/api/routing-group/routing-group-api.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Component({
  selector: 'routing-groups-panel',
  templateUrl: './routing-groups-panel.component.html',
  styleUrls: ['./routing-groups-panel.component.less']
})
export class RoutingGroupsPanelComponent implements OnInit, OnChanges {

  @Input()
  groups: any = [];

  @Input()
  selectedGroup: any;

  @Output()
  selectChanged = new EventEmitter<any>();

  @Output()
  deleteRequested = new EventEmitter<any>();

  @Output()
  editRequested = new EventEmitter<any>();

  @Output()
  moveRequested = new EventEmitter<any>();

  panelTitle: string;
  isUnauthorized: boolean;

  @ViewChild(VirtualScrollerComponent, {static: false})
  private virtualScroller: VirtualScrollerComponent;

  constructor(private userPrivilege: UserPrivilegeService,
              private routingGroupApiService: RoutingGroupApiService) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.ROUTING);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const groups: SimpleChange = changes.groups;
    const selected: SimpleChange = changes.selectedGroup;
    if (groups) {
      this.panelTitle = `Routing groups (${groups.currentValue.length})`;
    }
    if (selected) {
      const index = this.groups.findIndex(item => item.id === selected.currentValue.id);
      this.scrollToView(index);
    }
  }

  selectGroup(group): void {
    this.selectChanged.emit(group);
  }

  onEditGroup(event, group): void {
    this.editRequested.emit(group);
  }

  onDeleteGroup(event, group): void {
    this.deleteRequested.emit(group);
  }

  onMoveGroup(event, group): void {
    this.moveRequested.emit(group);
  }

  drop(event: CdkDragDrop<string[]>, viewPortInfo): void {
    if (this.isUnauthorized) { return; }

    const fromIndex = viewPortInfo.startIndexWithBuffer + event.previousIndex;
    const toIndex = viewPortInfo.startIndexWithBuffer + event.currentIndex;

    if (_.isEqual(toIndex, fromIndex)) { return; }

    this.moveItemInGroups(fromIndex, toIndex);

    const dragObject = {
      nextId: this.groups[toIndex + 1] ? this.groups[toIndex + 1].id : -1,
      prevId: this.groups[toIndex - 1] ? this.groups[toIndex - 1].id : -1,
      item: this.groups[toIndex]
    };

    const formattedGroup = this.createGroupToDrag(dragObject);

    this.routingGroupApiService.editGroup(formattedGroup).then().catch(() => {
      this.moveItemInGroups(toIndex, fromIndex);
    }).catch(() => {});
  }

  onDrag(): void {
    WindowActionsService.clearWindowSelections();
  }

  moveItemInGroups(fromIndex, toIndex): void {
    moveItemInArray(this.groups, fromIndex, toIndex);
    this.groups = [...this.groups];
  }

  isSelected(group): boolean {
    return _.isEqual(group, this.selectedGroup);
  }

  scrollToView(index): void {
    if (!this.virtualScroller) {
      return;
    }
    const startIndex = this.virtualScroller.viewPortInfo.startIndex;
    const endIndex = this.virtualScroller.viewPortInfo.endIndex;

    if (startIndex > index || index > endIndex) {
      this.virtualScroller.scrollToIndex(index);
    }
  }

  private createGroupToDrag(dragObject): any {
    return {
      id: dragObject.item.id,
      prevRRGroupId: dragObject.prevId,
      nextRRGroupId: dragObject.nextId,
      name: dragObject.item.name,
      tbrConditionsIds: dragObject.item.tbrConditionsIds,
      adminState: 'UNLOCKED'
    };
  }
}
